var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgTurtle = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 48,
    viewBox: "0 0 60 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.3625 27H6.63656C4.62844 27 3 25.3687 3 23.3625V21C3 10.9781 10.9781 3 21 3C30.9375 3 39 10.9781 39 21V23.3625C39 25.3687 37.3688 27 35.3625 27Z",
    fill: "#D0D3DA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M36 35.9812V41.25C36 43.3219 34.3219 45 32.25 45H27.75C25.6781 45 24 43.3219 24 41.25V36H18V41.25C18 43.3219 16.3219 45 14.25 45H9.75C7.67906 45 6 43.3219 6 41.25V36H3C1.34344 36 0 34.6594 0 33C0 31.3406 1.34344 30 3 30H35.25C38.9813 30 42 26.9813 42 23.25V15C42 11.6906 44.6906 9 48 9H51C55.9688 9 60 12.9469 60 18V21C60 24.3094 57.3094 27 54 27H48C47.8125 27 47.625 26.9906 47.4469 26.9719C45.9281 31.9688 41.4188 35.6625 36 35.9812ZM49.5 21C50.325 21 51 20.325 51 19.5C51 18.675 50.325 18 49.5 18C48.675 18 48 18.675 48 19.5C48 20.325 48.675 21 49.5 21Z",
    fill: "#D0D3DA"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgTurtle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/turtle.725561ea751a64d7de9e893b6a0c0b91.svg";